import React from 'react';

import AempUserIcon from '../icons/aemp-user-icon';
import { pushOrRedirect } from '../commons/query';
import Button from '../commons/component/button';
import config from '../generated/config';
import { dispatchMetric } from '../metrics';
import { dispatchLoadEvent } from './metrics';

const { url } = config;

export default class CadastroPjFinishComponent extends React.Component {
  componentDidMount() {
    dispatchLoadEvent('signUpPJ');
  }
  render() {
    return (
      <div className="cadastroForm-container">
        <div className="cadastroHeader">
          <h2 className="cadastroForm-title">
            <AempUserIcon />
            <span>cadastro</span>
          </h2>
        </div>
        <div className="finishContainer">
          <h3 className="finishTitle">seu cadastro foi efetuado com sucesso!</h3>
          <p className="finishSubtitle">
            é um prazer ter você conosco. agora você pode aproveitar os melhores preços e condições
            da Americanas Empresas.
          </p>
          <p className="finishSubtitle">
            enviaremos mais informações para o e-mail informado durante o cadastro.
          </p>
          <p className="finishSubtitle">
            para qualquer dúvida ou problema com sua conta, acesse a área de suporte e atendimento
            ao cliente.
          </p>
        </div>

        <div className="cadastro-buttons">
          <Button primary className="cadastroForm-submit" onClick={this.goToBasket} type="button">
            finalizar compra
          </Button>
          <button className="btn button-ghost" onClick={this.goToHome} type="button">
            voltar para a home
          </button>
          <button className="btn button-ghost" onClick={this.goToMyAccount} type="button">
            ir para minha conta
          </button>
        </div>
      </div>
    );
  }

  eventType = 'event_signup';

  goToHome = e => {
    dispatchMetric(this.eventType, {
      payload: {
        event: this.eventType,
        eventCategory: 'cadastro',
        eventAction: 'continuar-comprando'
      }
    });
    e.preventDefault();
    pushOrRedirect(null, {
      url: url.home
    });
  };

  goToBasket = e => {
    dispatchMetric(this.eventType, {
      payload: {
        event: this.eventType,
        eventCategory: 'cadastro',
        eventAction: 'finalizar-compra'
      }
    });
    e.preventDefault();
    pushOrRedirect(null, {
      url: url.basket
    });
  };

  goToMyAccount = e => {
    dispatchMetric(this.eventType, {
      payload: {
        event: this.eventType,
        eventCategory: 'cadastro',
        eventAction: 'minha-conta'
      }
    });
    e.preventDefault();
    pushOrRedirect(null, {
      url: url.myAccount
    });
  };
}
